module.exports = __webpack_public_path__ + "img/about2.a672c633.png";